import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import {
  searchByPageSync
} from "app/services/ServiceRequestItemService";
import { syncService } from "app/services/SyncCRMService";

export default class ServiceAsyncStore {
  searchRegisterService = {
    ...new SearchObject(),
    fromLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    toLastDateSync: new Date(),
    departmentId: null,
    isSyncedToCRM: false,
  };
  resetSelectedRows = false;

  pageRegisterService = new PageResponse();
  selectServiceAsync = [];

  constructor() {
    makeAutoObservable(this);
  }

  pagingRegisterService = async () => {
    let { healthCareSvId, groupId, departmentId, ...ortherData } =
      this.searchRegisterService;
    if (healthCareSvId) {
      ortherData.healthCareSvId = healthCareSvId?.id;
    }
    if (groupId) {
      ortherData.groupId = groupId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await searchByPageSync({ ...ortherData })
      .then(({ data }) => {
        this.pageRegisterService = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tư vấn khách hàng có lỗi");
      });
  };

  handleChangeFormSearchService = (searchRegisterService) => {
    this.searchRegisterService = {
      ...this.searchRegisterService,
      ...searchRegisterService,
    };
    this.pagingRegisterService();
  };

  setSelectServiceAsync = (list) => {
    this.selectServiceAsync = list;
  };
  syncListServiceToCrm = async () => {
    const serviceIds = this.selectServiceAsync?.map((el) => el?.id);
    this.resetSelectedRows = !this.resetSelectedRows;

    return await syncService(serviceIds)
      .then(({ data }) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        if (data) {
          toast.success("Đồng bộ dịch vụ thành công");
          this.pagingRegisterService();
        } else {
          toast.error("Đồng bộ dịch vụ có lỗi");
        }
      })
      .catch((error) => {
        this.resetSelectedRows = !this.resetSelectedRows;
        this.selectPatientAsync = [];
        console.error(error);
        toast.error("Đồng bộ dịch vụ có lỗi");
      });
  };

  resetStore = () => {
    this.searchRegisterService = {
      ...new SearchObject(),
      fromLastDateSync: new Date(),
      toLastDateSync: new Date(new Date().setMonth(new Date().getMonth() - 1)),
    };
    this.pageRegisterService = new PageResponse();
  };
}
